import { render, staticRenderFns } from "./CategoriesTable.vue?vue&type=template&id=7375aa0e&"
import script from "./CategoriesTable.vue?vue&type=script&lang=ts&"
export * from "./CategoriesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports